import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { queryNotifyList, socialLoginNotifyIsopen, notifyPreview, getEmailSignature, editEmailSignature } from "@/services/systemsetting";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import TinymceEditor from '@/components/tinymce';
import { handleLanguage } from '@/utils/util.js';
export default {
  components: {
    StandardTableVue: StandardTableVue,
    TinymceEditor: TinymceEditor
  },
  i18n: require("./../i18n-basucSettings"),
  props: ["systemSetting"],
  watch: {
    systemSetting: function systemSetting() {
      this.systemSettingData = this.systemSetting;
      this.initData();
    }
  },
  data: function data() {
    var columns = [{
      dataIndex: 'showOrder',
      title: this.$t('emailNumber'),
      scopedSlots: {
        customRender: 'showOrder'
      }
    }, {
      title: this.$t('emailNotify'),
      dataIndex: 'nfTypeName',
      width: '500px'
    }, {
      title: this.$t('emailState'),
      dataIndex: 'switchStatus',
      scopedSlots: {
        customRender: 'switchStatus'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      align: 'center'
    }];
    return {
      data: [],
      columns: columns,
      defaultLangObj: {},
      languageList: [],
      loadingSave: false,
      tabKey: "",
      systemSettingData: this.systemSetting,
      dataForm: {
        seoList: []
      },
      showHtml: false,
      html: '',
      signatureList: []
    };
  },
  mounted: function mounted() {
    this.defaultLangObj = JSON.parse(localStorage.getItem("defaultLangObj"));
    this.tabKey = this.defaultLangObj.langId;
    this.languageList = JSON.parse(localStorage.getItem("langList")).splice(0, 3);
    this.initData();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      this.tabKey = activeKey;
    },
    initData: function initData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$getEmailSignat, data, newdata, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getEmailSignature();
            case 1:
              _yield$getEmailSignat = _context.v;
              data = _yield$getEmailSignat.data;
              if (data.code == 200) {
                newdata = handleLanguage(data.data, _this.formatHtml2Text);
                _this.dataForm.seoList = _.cloneDeep(newdata);
              }
              // self.languageList.forEach((item) => {
              //   let objDetail = {};
              //   objDetail.langId = item.langId;
              //   objDetail.languageName = item.langName;
              //   let content = this.signatureList.filter(item2 => {
              //     return  Number(Object.keys(item2)[0]) == Number(item.langId)
              //   })
              //   if(content.length > 0) {
              //       objDetail.content = content[0][item.langId] ? this.formatHtml2Text(content[0][item.langId]) : ''
              //   } else {
              //       objDetail.content = ''
              //   }

              //   seoList.push(objDetail);
              // });
              // self.dataForm.seoList = seoList;
              //获取通知列表的数据
              _context.n = 2;
              return queryNotifyList(3);
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                _this.data = res.data.data;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /* 保存 */save: function save() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var self, params, _yield$editEmailSigna, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              self = _this2;
              params = _this2.dataForm.seoList.map(function (item) {
                return {
                  // [item.langId] : this.formatText2Html(item.content) 
                  langId: item.langId,
                  content: _this2.formatText2Html(item.content)
                };
              });
              _context2.p = 1;
              self.loadingSave = true;
              _context2.n = 2;
              return editEmailSignature({
                'settingContent': params
              });
            case 2:
              _yield$editEmailSigna = _context2.v;
              data = _yield$editEmailSigna.data;
              if (data.code == 200) {
                setTimeout(function () {
                  _this2.$message.success(_this2.$t("public.saveSuccessfully"));
                }, 500);
              }
            case 3:
              _context2.p = 3;
              setTimeout(function () {
                self.loadingSave = false;
              }, 500);
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1,, 3, 4]]);
      }))();
    },
    // 富文本图片上传
    imgUpload: function imgUpload(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('type', 8);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      console.log('上传');
      success('aaa');
      // upload(formData).then(res => {
      // 	if (res.data.code == 200) {
      // 		success(res.data.data.urlpath + res.data.data.uploadfilepath);
      // 	}
      // });
    },
    confirm: function confirm(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                id: row.id,
                status: 1 - row.switchStatus
                // nfTyp:e.nfType
              };
              _context3.n = 1;
              return socialLoginNotifyIsopen(params);
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.updateSuccessfully'));
                _this3.initData();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    cancel: function cancel() {
      // this.$message.error(this.$t('public.cancelSuccessfully'));
    },
    notifyPreviewMethod: function notifyPreviewMethod(e, val) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              console.log(val);
              params = {
                nfWay: 3,
                nfType: e.nfType,
                langId: val
              };
              _context4.n = 1;
              return notifyPreview(params);
            case 1:
              res = _context4.v;
              if (res.data.code == 200) {
                // something....
                _this4.html = res.data.data;
                if (_this4.html) {
                  _this4.showHtml = true;
                } else {
                  _this4.$message.warning(_this4.$t('public.noPreview'));
                }
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    canacelHtml: function canacelHtml() {
      this.showHtml = false;
    },
    formatText2Html: function formatText2Html(text) {
      var html = text;
      if (html) {
        html = html.replace(/ /g, '&nbsp;');
        html = html.replace(/\n/g, '<br/>');
      }
      return html;
    },
    formatHtml2Text: function formatHtml2Text(html) {
      var text = html;
      if (text) {
        text = text.replace(/&nbsp;/g, ' ');
        text = text.replace(/<br\/>/g, '\n');
      }
      return text;
    }
  }
};